"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'project.form.title.edit': 'Modifica progetto',
    'project.form.title.add': 'Aggiungi progetto',
    'project.form.back': 'Indietro',
    'project.form.color.placeholder': '#007bff',
    'project.form.icon.placeholder': 'fas fa-folder',
};
